import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StudentEngagementData } from '../models/engagement-student.model';
import { CopyEngagement } from '../models/copy-engagement.model';
import { AttendanceFilter } from '../../attendance/models/attendance-filter.model';
import { SchoolEngagementData } from '../models/engagement-school.model';

@Injectable({
  providedIn: 'root'
})
export class EngagementService {

  private apiUrl = `${environment.sgcApi}`;
  private engagementRoute = 'engagement';

  constructor(
    private httpClient: HttpClient
  ) {}

  addStudentEngagement(createStudentEngagementModel: StudentEngagementData, user: string) : Observable<number> {
    const endpointUrl = `${this.apiUrl}${this.engagementRoute}/user/${user}/student`;
    return this.httpClient
      .post<number>(endpointUrl, JSON.stringify(createStudentEngagementModel))
      .pipe(map((data) => data));
  }

  editStudentEngagement(createStudentEngagementModel: StudentEngagementData, user: string) {
    const endpointUrl = `${this.apiUrl}${this.engagementRoute}/user/${user}/student`;
    return this.httpClient
      .put(endpointUrl, JSON.stringify(createStudentEngagementModel))
      .pipe(map((data) => data));
  }

  deleteStudentEngagement(engagementId: number, studentId: number) {
    const endpointUrl = `${this.apiUrl}${this.engagementRoute}/engagementId/${engagementId}/studentId/${studentId}`;
    return this.httpClient.delete(endpointUrl)
      .pipe(map((data) => data));
  }

  copyEngagements(copyEngagement: CopyEngagement) : Observable<any>{
    const endpointUrl = `${this.apiUrl}${this.engagementRoute}/students/copy`;
    return this.httpClient.post(endpointUrl, JSON.stringify(copyEngagement));
  }

  deleteSchoolService(schoolEngagementId: number, schoolId: number) {
    let endpoint = `${this.apiUrl}${this.engagementRoute}/engagementId/${schoolEngagementId}/schoolId/${schoolId}`;
    return  this.httpClient.delete<any>(endpoint).pipe(
      map(data => data)
    );
  }

  getSchoolEngagement(schoolId: number, serviceId: number, year: number, month: number, day: number) {
    let endpoint = `${this.apiUrl}${this.engagementRoute}/schoolId/${schoolId}/serviceId/${serviceId}/year/${year}/month/${month}/day/${day}`;
    return this.httpClient.get<SchoolEngagementData>(endpoint)
    .pipe(map((data) => data));
  }
}
